import { MapfreButtonComponent } from '../../../../../modules/mapfre-design-library/src/lib/_components/individual-components/inputs/mapfre-button/mapfre-button.component';
import { MapfreLoadingComponent } from '../../../../../modules/mapfre-design-library/src/lib/_components/individual-components/mapfre-loading/mapfre-loading.component';
import { AttentionInfoComponent } from '../../attention-info/attention-info.component';
import { ImpNoticeComponent } from '../../imp-notice/imp-notice.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { MapfreDesignLibraryModule } from '../../../../../modules/mapfre-design-library/src/public_api';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { FormsModule , ReactiveFormsModule } from '@angular/forms';
import { DatePipe } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Params, Router , RouterModule } from '@angular/router';
import { Constants } from '@models/constants';
import { PolicyDataService } from './../../../../../_services/data-services/policy-data.service';
import { AutopayBillingService } from './../../../../../_services/my-insurance/autopay-billing.service';
import { PolicyDetailsService } from './../../../../../_services/my-insurance/policy-details.service';
import { TranslateService } from '@ngx-translate/core';
import { AcmicService } from '@mapfre-design-library/src/public_api';

@Component({
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule, RouterModule, TranslateModule, MapfreDesignLibraryModule, NgSelectModule, ImpNoticeComponent, AttentionInfoComponent, MapfreLoadingComponent, MapfreButtonComponent],
  selector: 'app-autopay-unenrolled',
  templateUrl: './autopay-unenrolled.component.html',
  styleUrls: ['./autopay-unenrolled.component.scss'],
  providers: [DatePipe],
})
export class AutopayUnenrolledComponent implements OnInit {
  loading = true;
  billedInvoice: boolean;
  moreThanTwoDays: boolean;
  twoDaysOrLess: boolean;
  impNoticeTxt: string;
  attentionInfoText: string;
  txtPara: string;
  btnText: string;
  policyId: string;
  policyType: string;
  billedWithdrawalDate: string;
  plannedWithdrawalDate: string;
  isAcmic = false;
  company: any;
  backIcon: string;
  outstandingBalance = 0;
  isUnenrollFromRecurringCCDC = false;
  constructor(
    private policyDataService: PolicyDataService,
    private policyDetailService: PolicyDetailsService,
    private autopayBillingService: AutopayBillingService,
    private activatedRoute: ActivatedRoute,
    private datePipe: DatePipe,
    private router: Router,
    private translate: TranslateService,
    private acmicService: AcmicService
  ) {
    this.billedInvoice = false;
    this.moreThanTwoDays = false;
    this.twoDaysOrLess = false;
  }

  dateCount(billedWithdrawalDate) {
    const withdrawalDateCount =
      this.policyDetailService.getDayDifference(billedWithdrawalDate);
    if (withdrawalDateCount <= 2) {
      this.twoDaysOrLess = true;
    } else if (withdrawalDateCount > 2) {
      this.moreThanTwoDays = true;
    }
  }
  setInfoText() {
    if (!this.billedInvoice || this.policyId.length === 6) {
      this.attentionInfoText = `Your next due date is <b>${this.datePipe.transform(
        this.plannedWithdrawalDate,
        Constants.DATE_MM_DD_YYYY
      )}</b> which will need to be paid manually.`;
      this.txtPara = 'Would you like to make a payment now?';
    } else {
      if (this.twoDaysOrLess) {
      console.log("twoDaysOrLess")
        this.impNoticeTxt = `Your next automatic payment is scheduled on <b>${this.datePipe.transform(
          this.billedWithdrawalDate,
          Constants.DATE_MM_DD_YYYY
        )}</b> and <b>cannot be stopped or changed</b>. Manual payments will begin after that.`;        
      }
      if (this.moreThanTwoDays) {
      console.log("moreThanTwoDays")
        
        this.impNoticeTxt = `Your next automatic payment is still scheduled for <b>${this.datePipe.transform(
          this.billedWithdrawalDate,
          Constants.DATE_MM_DD_YYYY
        )}</b>. Manual payments will begin after that.`;
        this.txtPara = `To discuss your options, please contact Customer Service at ${this.translate.instant(
          'CUSTOMER_SERVICE_NUMBER'
        )}.`;
      }
    }
  }
  ngOnInit(): void {
    this.isAcmic = this.acmicService.isACMIC();
    this.backIcon = this.isAcmic ? 'assets/img/images/back-arrow-blue-005095.svg' : 'assets/img/images/back-arrow-red.svg';
    this.activatedRoute.params.subscribe((params: Params) => {
      this.policyId = params['policyid'];
      this.policyDataService.$policyDetails.subscribe((policyResponse) => {
        if (policyResponse && policyResponse.length) {
          const policy = policyResponse.find(policyData => policyData.policynumber.policyNumber === this.policyId);
          this.policyType = policy?.displayType?.label?.toLowerCase();
          this.company = policy.company.companyName 
          this.isUnenrollFromRecurringCCDC = (this.company === 'TW' && !policy?.policyFlags?.isEft?.includes('PENDING'));
          this.outstandingBalance = policy?.billingDetails[0]?.outstandingbalance    
          if (policy && policy.scheduleBills && policy.scheduleBills.length) {
            policy.scheduleBills.filter(scheduledBill => {
              if (scheduledBill.invoiceState === "Billed") {
                this.billedInvoice = true;
                this.billedWithdrawalDate = scheduledBill.dateDue;
                this.dateCount(this.billedWithdrawalDate);
              }
            });
            const sortedPlannedBills =
              this.autopayBillingService.getSortedPlannedBills(policy);
            this.plannedWithdrawalDate =
              sortedPlannedBills &&
              sortedPlannedBills[0] &&
              sortedPlannedBills[0].dateDue;
            this.setInfoText();
          }
          this.loading = false;
        }
      });
    });
  }

  openAutoPay() {
    this.router.navigate(['/billing', 'autopay']);
  }
  payNow(event) {
    void event;
    this.router.navigate(['/billing-new', this.policyId, 'make-a-payment']);
  }
}
